export const SPINNER_DELAY = 250;
//# sourceMappingURL=constants.js.map